import React from 'react'
import { Button } from 'react-bootstrap'

// Mesmas opções do menu de seleção do WhatsApp
const FORMATS = [
  { marker: '*', label: <b>N</b>, title: 'Negrito: *texto*' },
  { marker: '_', label: <i>I</i>, title: 'Itálico: _texto_' },
  { marker: '~', label: <s>T</s>, title: 'Tachado: ~texto~' },
  { marker: '```', label: <span className='font-monospace'>{'</>'}</span>, title: 'Monoespaçado: ```texto```' },
]

// Envolve o trecho selecionado com o marcador do WhatsApp. Sem seleção, abre o par e deixa o cursor no meio.
// Os espaços nas pontas da seleção ficam de fora: "* texto*" não vira negrito no WhatsApp.
const WhatsappFormatButtons = ({ inputRef, value, onChange, disabled, maxLength }) => {
  function wrap(marker) {
    const input = inputRef.current
    let start = input ? input.selectionStart : value.length
    let end = input ? input.selectionEnd : value.length

    while ((start < end) && /\s/.test(value[start])) start++
    while ((end > start) && /\s/.test(value[end - 1])) end--

    if (maxLength && (value.length + (marker.length * 2) > maxLength)) return

    onChange(value.slice(0, start) + marker + value.slice(start, end) + marker + value.slice(end))

    requestAnimationFrame(() => {
      if (!input) return
      input.focus()
      input.setSelectionRange(start + marker.length, end + marker.length)
    })
  }

  return (
    <div className='d-flex flex-wrap gap-1' role='group' aria-label='Formatação do WhatsApp'>
      {FORMATS.map((item) => (
        <Button key={item.marker} variant='outline-secondary' size='sm' className='birthdays-format-button' disabled={disabled} title={item.title} aria-label={item.title} onClick={() => wrap(item.marker)}>
          {item.label}
        </Button>
      ))}
    </div>
  )
}

export default WhatsappFormatButtons
